import React, { useEffect, useState } from 'react'
import logo from '../assets/logo.png'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import userIcon from '../assets/user.png'
import { IoSearchOutline } from "react-icons/io5";
import { navigation } from '../contants/navigation';


const Header = () => {
    const location = useLocation()
    const removeSpace = location?.search?.slice(3)?.split("%20")?.join(" ")
    const [searchInput,setSearchInput] = useState(removeSpace)
    const navigate = useNavigate()
   
    useEffect(()=>{
        if(searchInput){
            navigate(`/search?q=${searchInput}`)
        }
    },[searchInput])

    const handleSubmit = (e)=>{
        e.preventDefault()
    }

  return (
    <header className='fixed top-0 w-full h-16 bg-almost-black border-b border-border-color backdrop-blur-md z-40'>
            <div className='container mx-auto px-3 flex items-center h-full'>
                <Link to={"/"}>
                    <img
                        src={logo}
                        alt='logo'
                        width={120} 
                        className='transition-opacity hover:opacity-80'
                    />
                </Link>

                <nav className='hidden lg:flex items-center gap-1 ml-5'>
                    {
                        navigation.map((nav,index)=>{
                            return(
                                <div key={nav.label+"header"+index}>
                                    <NavLink to={nav.href} className={({isActive})=>`px-4 py-2 rounded-lg transition-all hover:bg-dark-gray-4 hover:text-very-light-gray ${isActive ? "text-very-light-gray bg-dark-gray-4" : "text-light-gray-2"}`}>
                                        {nav.label}
                                    </NavLink>
                                </div>
                            )
                        })
                    }
                </nav>

                <div className='ml-auto flex items-center gap-5'>
                    <form className='flex items-center gap-2' onSubmit={handleSubmit}>
                        <input
                            type='text'
                            placeholder='Search here...'
                            className='bg-dark-gray-3 border border-border-color rounded-lg px-4 py-2 outline-none text-very-light-gray placeholder-light-gray-1 focus:border-dark-gray-6 focus:bg-dark-gray-4 transition-all hidden lg:block'
                            onChange={(e)=>setSearchInput(e.target.value)}
                            value={searchInput}
                        />
                        <button className='text-2xl text-very-light-gray hover:text-white transition-colors'>
                                <IoSearchOutline/>
                        </button>
                    </form>
                    <div className='w-8 h-8 rounded-full overflow-hidden cursor-pointer hover:ring-2 ring-border-color transition-all'>
                        <img
                            src={userIcon}
                            alt='user'
                            className='w-full h-full object-cover'
                        />
                    </div>
                </div>
            </div>
    </header>
  )
}

export default Header
